import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./Home.module.scss";
import { useTranslation } from "react-i18next";
import CustomButton from "../../components/ui/CustomButton/CustomButton";

import sendWhite from "../../assets/images/icons/send-white.svg";
import whyKoin from "../../assets/images/home/why-join.png";
import noUpfortCost from "../../assets/images/home/no-upfort-cost.svg";
import increasedVisibility from "../../assets/images/home/increased-visibility.svg";
import smartScheduling from "../../assets/images/home/smart-scheduling.svg";
import exclusivePerks from "../../assets/images/home/exclusive-perks.svg";
import searchGrey from "../../assets/images/icons/search-grey.svg";
import linkIcon from "../../assets/images/icons/link.svg";
import starsIcon from "../../assets/images/icons/stars.svg";
import { useState } from "react";
import ComingSoonPopup from "../../components/ComingSoonPopup/ComingSoonPopup";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { textCropping } from "../../helper/language";
import { environment } from "../../environment";
import useAppSelector from "../../hooks/useAppSelector";
import Slider from "react-slick";

import heroSlide01 from "../../assets/images/home/hero-slide-01.png";
import heroSlide02 from "../../assets/images/home/hero-slide-02.png";
import heroSlide03 from "../../assets/images/home/hero-slide-03.png";
import heroSlide04 from "../../assets/images/home/hero-slide-04.png";
import heroSlide05 from "../../assets/images/home/hero-slide-05.png";
import heroSlide06 from "../../assets/images/home/hero-slide-06.png";

const Home = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [showComingSoonPopup, setShowComingSoonPopup] = useState<boolean>(false);
  const { isAuthorized } = useAppSelector((state) => state.userProfileSlice);

  const activeLanguage = i18n.language as "en" | "gr";

  const redirectToCalendly = () => {
    window.open("https://calendly.com/clubpass/30min", "_blank");
  };

  const sliderSettings = {
    className: "center",
    centerMode: true,
    centerPadding: "60px",
    slidesToShow: 4,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    speed: 10000,
    infinite: true,
    dots: false,
    arrows: false,
    focusable: false,
    responsive: [
      {
        breakpoint: 1956,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 2,
          centerPadding: "240px",
        },
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          centerPadding: "60px",
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          centerPadding: "40px",
        },
      },
    ],
  };

  return (
    <>
      <Helmet>
        <title>{t("GymPass24HourFitnessPass")}</title>
        <meta name="description" content={t("LookingForFlexibleFitnessOptions")} />
        <meta
          name="keywords"
          content="Gym Pass, 24 Hour Fitness Pass, Wellness Center Guest Pass"
        />
      </Helmet>
      <div className={styles.page}>
        {/*Hero section*/}
        <section className={styles["hero"]}>
          <div className="container">
            <div className={styles["wrapper"]}>
              <div className={styles["box"]}>
                <h1>
                  {!isAuthorized ? t("ClubPassIsAlmostHereAreYou") : t("YourAllAccessPassToFitness")}
                </h1>
                <p>
                  {!isAuthorized
                    ? t("ANewWayToDiscoverAndBookFitnessWellnessWithOneSimple")
                    : t("BookUnlimitedGymSessionsFitnessClasses")}
                </p>

                {!isAuthorized && (
                  <div className={styles["btns-wrapper"]}>
                    <CustomButton
                      functionOnClick={() => navigate("/register")}
                      text={t("PreRegisterNow")}
                      type={"button"}
                      typeStyle={"fill"}
                    />
                  </div>
                )}

                {isAuthorized && (
                  <>
                    <div className={styles["btns-wrapper"]}>
                      <CustomButton text={t("Get7DaysFree")} type={"button"} typeStyle={"fill"} />
                      <CustomButton
                        functionOnClick={() => navigate("/learn-more")}
                        text={t("LearnMore")}
                        type={"button"}
                        typeStyle={"outline"}
                      />
                    </div>
                    <Link to={"/gyms-location"} className={styles["link"]}>
                      {t("BrowseClassesAndAppointments")}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_29462_19296)">
                          <path
                            d="M11.643 4.46178L16.1215 8.94024C16.2699 9.0887 16.3533 9.29002 16.3533 9.49995C16.3533 9.70987 16.2699 9.9112 16.1215 10.0597L11.643 14.5381C11.4937 14.6823 11.2938 14.7621 11.0862 14.7603C10.8786 14.7585 10.68 14.6753 10.5333 14.5285C10.3865 14.3817 10.3032 14.1831 10.3014 13.9756C10.2996 13.768 10.3794 13.568 10.5236 13.4187L13.6507 10.2916H3.16667C2.9567 10.2916 2.75534 10.2082 2.60687 10.0597C2.45841 9.91127 2.375 9.70991 2.375 9.49995C2.375 9.28998 2.45841 9.08862 2.60687 8.94015C2.75534 8.79169 2.9567 8.70828 3.16667 8.70828H13.6507L10.5236 5.5812C10.448 5.50817 10.3877 5.42081 10.3462 5.32422C10.3047 5.22764 10.2829 5.12376 10.282 5.01864C10.2811 4.91352 10.3011 4.80928 10.3409 4.71198C10.3807 4.61469 10.4395 4.5263 10.5138 4.45197C10.5881 4.37764 10.6765 4.31885 10.7738 4.27905C10.8711 4.23924 10.9754 4.21921 11.0805 4.22012C11.1856 4.22104 11.2895 4.24288 11.3861 4.28437C11.4827 4.32586 11.57 4.38617 11.643 4.46178Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_29462_19296">
                            <rect width="19" height="19" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </Link>
                  </>
                )}

              </div>
            </div>
          </div>
          <div className={styles["slider-wrapper"]}>
            <Slider {...sliderSettings}>
              <div className={styles["slider-item"]}>
                <img src={heroSlide01} alt={"slide-01"} />
              </div>
              <div className={styles["slider-item"]}>
                <img src={heroSlide02} alt={"slide-02"} />
              </div>
              <div className={styles["slider-item"]}>
                <img src={heroSlide03} alt={"slide-03"} />
              </div>
              <div className={styles["slider-item"]}>
                <img src={heroSlide04} alt={"slide-04"} />
              </div>
              <div className={styles["slider-item"]}>
                <img src={heroSlide05} alt={"slide-05"} />
              </div>
              <div className={styles["slider-item"]}>
                <img src={heroSlide06} alt={"slide-06"} />
              </div>
            </Slider>
          </div>
        </section>

        {/*How Clubpass works*/}
        <section className={`${styles["how"]} container`}>
          <h2 className={styles["title"]}>{t("HowClubPassWorks")}</h2>
          <div className={styles["wrapper"]}>
            <div className={styles["item"]}>
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M20 3.33341C20.4421 3.33341 20.866 3.50901 21.1786 3.82157C21.4911 4.13413 21.6667 4.55805 21.6667 5.00008C21.6667 5.44211 21.4911 5.86603 21.1786 6.17859C20.866 6.49115 20.4421 6.66675 20 6.66675H13.3334C12.8913 6.66675 12.4674 6.84234 12.1549 7.1549C11.8423 7.46746 11.6667 7.89139 11.6667 8.33341V31.6667C11.6667 32.1088 11.8423 32.5327 12.1549 32.8453C12.4674 33.1578 12.8913 33.3334 13.3334 33.3334H26.6667C27.1087 33.3334 27.5327 33.1578 27.8452 32.8453C28.1578 32.5327 28.3334 32.1088 28.3334 31.6667V20.0001C28.3334 19.5581 28.509 19.1341 28.8215 18.8216C29.1341 18.509 29.558 18.3334 30 18.3334C30.4421 18.3334 30.866 18.509 31.1786 18.8216C31.4911 19.1341 31.6667 19.5581 31.6667 20.0001V31.6667C31.6667 32.9928 31.1399 34.2646 30.2022 35.2023C29.2646 36.14 27.9928 36.6667 26.6667 36.6667H13.3334C12.0073 36.6667 10.7355 36.14 9.79784 35.2023C8.86016 34.2646 8.33337 32.9928 8.33337 31.6667V8.33341C8.33337 7.00733 8.86016 5.73556 9.79784 4.79788C10.7355 3.8602 12.0073 3.33341 13.3334 3.33341H20ZM20 26.6667C20.6631 26.6667 21.299 26.9301 21.7678 27.399C22.2366 27.8678 22.5 28.5037 22.5 29.1667C22.5 29.8298 22.2366 30.4657 21.7678 30.9345C21.299 31.4034 20.6631 31.6667 20 31.6667C19.337 31.6667 18.7011 31.4034 18.2323 30.9345C17.7634 30.4657 17.5 29.8298 17.5 29.1667C17.5 28.5037 17.7634 27.8678 18.2323 27.399C18.7011 26.9301 19.337 26.6667 20 26.6667ZM30 1.66675C30.3477 1.66689 30.6866 1.77574 30.9693 1.97806C31.252 2.18039 31.4644 2.46606 31.5767 2.79508L31.7934 3.42508C32.04 4.14801 32.449 4.8048 32.989 5.34507C33.529 5.88533 34.1856 6.2947 34.9084 6.54175L35.5384 6.75675C35.867 6.86937 36.1523 7.08188 36.3542 7.36457C36.5562 7.64726 36.6648 7.986 36.6648 8.33341C36.6648 8.68083 36.5562 9.01957 36.3542 9.30226C36.1523 9.58495 35.867 9.79746 35.5384 9.91008L34.9084 10.1267C34.1855 10.3734 33.5287 10.7824 32.9884 11.3224C32.4481 11.8624 32.0388 12.519 31.7917 13.2417L31.5767 13.8717C31.4641 14.2004 31.2516 14.4857 30.9689 14.6876C30.6862 14.8896 30.3475 14.9981 30 14.9981C29.6526 14.9981 29.3139 14.8896 29.0312 14.6876C28.7485 14.4857 28.536 14.2004 28.4234 13.8717L28.2067 13.2417C27.96 12.5188 27.551 11.862 27.0111 11.3218C26.4711 10.7815 25.8145 10.3721 25.0917 10.1251L24.4617 9.91008C24.133 9.79746 23.8478 9.58495 23.6458 9.30226C23.4439 9.01957 23.3353 8.68083 23.3353 8.33341C23.3353 7.986 23.4439 7.64726 23.6458 7.36457C23.8478 7.08188 24.133 6.86937 24.4617 6.75675L25.0917 6.54008C25.8146 6.29342 26.4714 5.88441 27.0117 5.34443C27.552 4.80445 27.9613 4.14787 28.2084 3.42508L28.4234 2.79508C28.5357 2.46606 28.748 2.18039 29.0308 1.97806C29.3135 1.77574 29.6524 1.66689 30 1.66675ZM30 6.99341C29.6057 7.48952 29.1561 7.93909 28.66 8.33341C29.1567 8.72675 29.605 9.17675 30 9.67341C30.3934 9.17675 30.8434 8.72675 31.34 8.33341C30.8439 7.93909 30.3944 7.48952 30 6.99341Z" fill="#FF8C42"/>
              </svg>
              <h4>{t("DownloadClubPass")}</h4>
              <p>{t("InstantAccessToTopGymsStudiosAndWellnessSpaces")}</p>
            </div>

            <div className={styles["item"]}>
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                <g clip-path="url(#clip0_33465_24134)">
                  <path d="M15.8333 3.3333C16.8912 3.33314 17.9095 3.73536 18.6817 4.45837C19.4539 5.18138 19.9223 6.17105 19.9916 7.22664L20 7.49997V15.175L29.07 16.1833C30.6425 16.3581 32.1016 17.0864 33.1864 18.2381C34.2713 19.3898 34.9111 20.8898 34.9916 22.47L35 22.8083V23.3333C34.9999 26.7973 33.6517 30.1254 31.2409 32.6128C28.83 35.1002 25.5457 36.5517 22.0833 36.66L21.6666 36.6666H20.5433C18.1474 36.6666 15.7958 36.021 13.7358 34.7977C11.6757 33.5744 9.98337 31.8186 8.83665 29.715L8.61831 29.2966L3.88165 19.8233C3.28165 18.6233 3.72665 17.0183 5.12665 16.4433C6.86498 15.7316 8.51665 15.5983 10.2183 16.4633C10.5883 16.6516 10.9516 16.8833 11.3083 17.1533L11.6666 17.4366V7.49997C11.6666 6.3949 12.1056 5.33509 12.887 4.55369C13.6684 3.77229 14.7282 3.3333 15.8333 3.3333ZM15.8333 6.66664C15.6383 6.66657 15.4494 6.73492 15.2995 6.85979C15.1497 6.98465 15.0484 7.15811 15.0133 7.34997L15 7.49997V21.6666C14.9997 22.0117 14.8924 22.3482 14.6927 22.6296C14.4931 22.911 14.211 23.1236 13.8855 23.2379C13.5599 23.3522 13.2069 23.3626 12.8751 23.2678C12.5434 23.1729 12.2492 22.9774 12.0333 22.7083L11.48 22.03L10.975 21.44C10.0083 20.345 9.30665 19.74 8.70831 19.435C8.35474 19.2436 7.95142 19.164 7.55165 19.2066L7.31665 19.24L11.6 27.8066C12.3999 29.4058 13.6139 30.7612 15.1156 31.7318C16.6173 32.7023 18.3517 33.2525 20.1383 33.325L20.5433 33.3333H21.6666C24.2539 33.3334 26.7406 32.3307 28.6041 30.5359C30.4676 28.741 31.563 26.2938 31.66 23.7083L31.6666 23.3333V22.8083C31.6667 22.0338 31.3971 21.2834 30.9041 20.6861C30.4111 20.0888 29.7255 19.6817 28.965 19.535L28.7016 19.495L19.6316 18.4883C18.8616 18.4028 18.1454 18.0517 17.6061 17.4954C17.0668 16.9391 16.7382 16.2123 16.6766 15.44L16.6666 15.175V7.49997C16.6666 7.27896 16.5788 7.06699 16.4226 6.91071C16.2663 6.75443 16.0543 6.66664 15.8333 6.66664ZM6.66665 9.99997C7.10867 9.99997 7.5326 10.1756 7.84516 10.4881C8.15772 10.8007 8.33331 11.2246 8.33331 11.6666C8.33331 12.1087 8.15772 12.5326 7.84516 12.8451C7.5326 13.1577 7.10867 13.3333 6.66665 13.3333H4.99998C4.55795 13.3333 4.13403 13.1577 3.82147 12.8451C3.50891 12.5326 3.33331 12.1087 3.33331 11.6666C3.33331 11.2246 3.50891 10.8007 3.82147 10.4881C4.13403 10.1756 4.55795 9.99997 4.99998 9.99997H6.66665ZM26.6666 8.3333C27.0914 8.33377 27.5 8.49643 27.8089 8.78805C28.1178 9.07967 28.3037 9.47823 28.3286 9.90229C28.3535 10.3264 28.2155 10.7439 27.9429 11.0697C27.6702 11.3954 27.2835 11.6048 26.8616 11.655L26.6666 11.6666H25C24.5752 11.6662 24.1666 11.5035 23.8577 11.2119C23.5488 10.9203 23.3629 10.5217 23.338 10.0976C23.3131 9.67358 23.4511 9.256 23.7238 8.93025C23.9964 8.60449 24.3832 8.39514 24.805 8.34497L25 8.3333H26.6666ZM7.84498 2.15497L9.51165 3.82164C9.81524 4.13597 9.98323 4.55698 9.97944 4.99397C9.97564 5.43097 9.80036 5.84899 9.49134 6.158C9.18233 6.46701 8.76431 6.6423 8.32731 6.64609C7.89032 6.64989 7.46932 6.4819 7.15498 6.1783L5.48831 4.51164C5.18472 4.1973 5.01673 3.7763 5.02052 3.3393C5.02432 2.90231 5.1996 2.48429 5.50862 2.17527C5.81763 1.86626 6.23565 1.69098 6.67264 1.68718C7.10964 1.68338 7.53064 1.85137 7.84498 2.15497ZM26.1783 2.15497C26.4908 2.46752 26.6663 2.89136 26.6663 3.3333C26.6663 3.77524 26.4908 4.19909 26.1783 4.51164L24.5116 6.1783C24.3579 6.33749 24.174 6.46446 23.9707 6.55181C23.7673 6.63915 23.5486 6.68513 23.3273 6.68705C23.106 6.68898 22.8865 6.64681 22.6817 6.56301C22.4769 6.4792 22.2908 6.35545 22.1343 6.19896C21.9778 6.04247 21.8541 5.85639 21.7703 5.65156C21.6865 5.44673 21.6443 5.22727 21.6462 5.00597C21.6482 4.78467 21.6941 4.56597 21.7815 4.36263C21.8688 4.15929 21.9958 3.97538 22.155 3.82164L23.8216 2.15497C24.1342 1.84252 24.558 1.66699 25 1.66699C25.4419 1.66699 25.8658 1.84252 26.1783 2.15497Z" fill="#FF8C42"/>
                </g>
                <defs>
                  <clipPath id="clip0_33465_24134">
                    <rect width="40" height="40" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              <h4>{t("TapToBook")}</h4>
              <p>{t("YourNextSessionIsJustTwoClicksAway")}</p>
            </div>

            <div className={styles["item"]}>
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                <g clip-path="url(#clip0_33465_24139)">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M5 8.33333C5 7.44928 5.35119 6.60143 5.97631 5.97631C6.60143 5.35119 7.44928 5 8.33333 5H11.6667C12.1087 5 12.5326 5.17559 12.8452 5.48816C13.1577 5.80072 13.3333 6.22464 13.3333 6.66667C13.3333 7.10869 13.1577 7.53262 12.8452 7.84518C12.5326 8.15774 12.1087 8.33333 11.6667 8.33333H8.33333V11.6667C8.33333 12.1087 8.15774 12.5326 7.84518 12.8452C7.53262 13.1577 7.10869 13.3333 6.66667 13.3333C6.22464 13.3333 5.80072 13.1577 5.48816 12.8452C5.17559 12.5326 5 12.1087 5 11.6667V8.33333ZM5 31.6667C5 32.5507 5.35119 33.3986 5.97631 34.0237C6.60143 34.6488 7.44928 35 8.33333 35H11.6667C12.1087 35 12.5326 34.8244 12.8452 34.5118C13.1577 34.1993 13.3333 33.7754 13.3333 33.3333C13.3333 32.8913 13.1577 32.4674 12.8452 32.1548C12.5326 31.8423 12.1087 31.6667 11.6667 31.6667H8.33333V28.3333C8.33333 27.8913 8.15774 27.4674 7.84518 27.1548C7.53262 26.8423 7.10869 26.6667 6.66667 26.6667C6.22464 26.6667 5.80072 26.8423 5.48816 27.1548C5.17559 27.4674 5 27.8913 5 28.3333V31.6667ZM31.6667 5C32.5507 5 33.3986 5.35119 34.0237 5.97631C34.6488 6.60143 35 7.44928 35 8.33333V11.6667C35 12.1087 34.8244 12.5326 34.5118 12.8452C34.1993 13.1577 33.7754 13.3333 33.3333 13.3333C32.8913 13.3333 32.4674 13.1577 32.1548 12.8452C31.8423 12.5326 31.6667 12.1087 31.6667 11.6667V8.33333H28.3333C27.8913 8.33333 27.4674 8.15774 27.1548 7.84518C26.8423 7.53262 26.6667 7.10869 26.6667 6.66667C26.6667 6.22464 26.8423 5.80072 27.1548 5.48816C27.4674 5.17559 27.8913 5 28.3333 5H31.6667ZM35 31.6667C35 32.5507 34.6488 33.3986 34.0237 34.0237C33.3986 34.6488 32.5507 35 31.6667 35H28.3333C27.8913 35 27.4674 34.8244 27.1548 34.5118C26.8423 34.1993 26.6667 33.7754 26.6667 33.3333C26.6667 32.8913 26.8423 32.4674 27.1548 32.1548C27.4674 31.8423 27.8913 31.6667 28.3333 31.6667H31.6667V28.3333C31.6667 27.8913 31.8423 27.4674 32.1548 27.1548C32.4674 26.8423 32.8913 26.6667 33.3333 26.6667C33.7754 26.6667 34.1993 26.8423 34.5118 27.1548C34.8244 27.4674 35 27.8913 35 28.3333V31.6667ZM28.2583 13.93C28.3895 13.6238 28.4259 13.2854 28.3629 12.9584C28.2999 12.6313 28.1404 12.3307 27.9049 12.0951C27.6693 11.8596 27.3687 11.7001 27.0416 11.6371C26.7146 11.5741 26.3761 11.6105 26.07 11.7417L9.57 18.8133C9.2473 18.9521 8.97669 19.1893 8.79682 19.491C8.61696 19.7928 8.53703 20.1436 8.56845 20.4935C8.59987 20.8434 8.74103 21.1744 8.97178 21.4392C9.20253 21.7041 9.51107 21.8893 9.85333 21.9683L16.4967 23.5017L18.03 30.1467C18.1086 30.4895 18.2937 30.7987 18.5587 31.0299C18.8238 31.2612 19.1552 31.4026 19.5055 31.4341C19.8558 31.4655 20.2071 31.3853 20.5091 31.205C20.8111 31.0246 21.0482 30.7534 21.1867 30.43L28.2583 13.93ZM18.2617 20.4883L15.5717 19.8683L23.5533 16.4467L20.1317 24.43L19.51 21.7383C19.44 21.4339 19.2858 21.1553 19.0651 20.9343C18.8444 20.7133 18.566 20.5588 18.2617 20.4883Z" fill="#FF8C42"/>
                </g>
                <defs>
                  <clipPath id="clip0_33465_24139">
                    <rect width="40" height="40" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              <h4>{t("LiveFlexible")}</h4>
              <p>{t("TrainWhereYouWantWhenYouWantNoCommitments")}</p>
            </div>
          </div>
        </section>

        {/* Why join */}
        <section className={`${styles.why} container`}>
          <div className={styles.info}>
            <h2 className={styles.title}>{t("WhyJoinClubPass")}</h2>
            <p className={styles.subtitle}>
              {t("ASmarterWayToBookYourWorkoutsAndWellnessTreatmentsAllInOnePlace")}
            </p>
            <CustomButton
              functionOnClick={redirectToCalendly}
              text={t("StartExploring")}
              type={"button"}
              typeStyle={"fill"}
              style={{ maxWidth: "280px" }}
            />
          </div>
          <img className={styles.image} src={whyKoin} alt={"Why Join?"} />
        </section>

        {/* Boost bookings */}
        <section className={`${styles.boost}`}>
          <div className={"container"}>
            <div className={styles.topWrapper}>
              <h2 className={styles.title}>{t("BoostYourBookingsListYourBusinessForFree")}</h2>
              <p className={styles.subtitle}>
                {t("JoinTheFastestGrowingFitnessWellnessNetworkInGreece")}
              </p>
              <CustomButton
                functionOnClick={redirectToCalendly}
                text={t("ListYourBusinessNow")}
                type={"button"}
                typeStyle={"fill"}
                style={{
                  display: "inline-flex",
                  width: "unset",
                }}
              />
            </div>

            <div className={styles.mainWrapper}>
              <div className={styles.item}>
                <img src={noUpfortCost} alt={t("NoUpfrontCost")} />
                <h3>{t("NoUpfrontCost")}</h3>
                <p>{t("GetListedFreePayOnlyPerBooking")}</p>
              </div>

              <div className={styles.item}>
                <img src={increasedVisibility} alt={t("IncreasedVisibility")} />
                <h3>{t("IncreasedVisibility")}</h3>
                <p>{t("ReachThousandsOfFitnessWellnessSeekers")}</p>
              </div>

              <div className={styles.item}>
                <img src={smartScheduling} alt={t("SmartScheduling")} />
                <h3>{t("SmartScheduling")}</h3>
                <p>{t("ManageYourAvailabilityAndBookingsEasily")}</p>
              </div>

              <div className={styles.item}>
                <img src={exclusivePerks} alt={t("ExclusivePerks")} />
                <h3>{t("ExclusivePerks")}</h3>
                <p className={styles.dot}>{t("OffGymEquipmentForClubPassPartners")}</p>
                <p className={styles.dot}>{t("OffTrainYourPulseCRMForManagingMemberships")}</p>
              </div>
            </div>
          </div>
        </section>

        {/* Find class */}
        <section className={styles.find}>
          <div className={`${styles.findContainer} container`}>
            <h2 className={styles.title}>{t("FindAClassBookInSeconds")}</h2>
            <p className={styles.subtitle}>
              {t("ExploreThousandsOfFitnessClassesWellnessTreatments")}
            </p>
            <div className={styles.customInput}>
              <div>
                <img src={searchGrey} alt={"Search"} />
                <input />
              </div>
              <CustomButton
                functionOnClick={() => setShowComingSoonPopup(true)}
                text={t("FindClasses")}
                type={"button"}
                typeStyle={"fill"}
                style={{ display: "inline-flex" }}
              />
            </div>
          </div>
        </section>

        {/* Articles */}
        <section className={`${styles.articles} container`}>
          <h2 className={styles.title}>{t("ExpertAdviceIndustryInsights")}</h2>
          <p className={styles.subtitle}>{t("ReadExpertFitnessTipsWellnessGuides")}</p>
          <div className={styles.wrapper}>
            <div className={styles.item}>
              <img
                className={styles.articleImg}
                src={`${environment.serverPath}/public/images/blog/article-01.png`}
                alt={"Article01"}
              />
              <h3>{textCropping(t("IntroducingClubpassGreeceNewWayToDiscoverGymsSalons"), 55)}</h3>
              <p>
                {textCropping(t("DiscoverClubpassTheDigitalPlatformThatLetsYouBookDayPasses"), 112)}
              </p>
              <Link
                target={"_blank"}
                to={
                  activeLanguage === "en"
                    ? "/blog/introducing-clubpass-greece-gyms-salons"
                    : "/blog/sas-parousiazoume-to-clubpass-gymnastiria-salonia-ellada"
                }
              >
                {t("ContinueReading")} <img src={linkIcon} alt={"Link"} />
              </Link>
            </div>

            <div className={styles.item}>
              <img
                className={styles.articleImg}
                src={`${environment.serverPath}/public/images/blog/article-02.png`}
                alt={"Article02"}
              />
              <h3>{textCropping(t("TiredOfExpensiveMembershipsTryAGymForADayInYourArea"), 55)}</h3>
              <p>{textCropping(t("ExploreAffordableGymDayPassesWithClubPassNoContracts"), 110)}</p>
              <Link
                target={"_blank"}
                to={
                  activeLanguage === "en"
                    ? "/blog/gym-day-pass-vs-membership-benefits"
                    : "/blog/gymnastirio-day-pass-vs-syndromi-ofeli"
                }
              >
                {t("ContinueReading")} <img src={linkIcon} alt={"Link"} />
              </Link>
            </div>

            <div className={styles.item}>
              <img
                className={styles.articleImg}
                src={`${environment.serverPath}/public/images/blog/article-03.png`}
                alt={"Article03"}
              />
              <h3>{textCropping(t("HowGymsAndSalonsInGreeceCanGetMoreClientsForFree"), 54)}</h3>
              <p>{textCropping(t("DiscoverHowGymsSalonsAndWellnessCentersInGreeceCanGet"), 110)}</p>
              <Link
                target={"_blank"}
                to={
                  activeLanguage === "en"
                    ? "/blog/how-gyms-and-salons-in-greece-can-get-free-clients"
                    : "/blog/pos-na-vreis-neous-pelates-dorean-gymnastirio-salon-ellada"
                }
              >
                {t("ContinueReading")} <img src={linkIcon} alt={"Link"} />
              </Link>
            </div>
          </div>
          <div className={"flex-just-center"}>
            <CustomButton
              text={t("ExploreMore")}
              type={"button"}
              typeStyle={"fill"}
              style={{
                display: "inline-flex",
                width: "unset",
              }}
              functionOnClick={() => navigate("/blog")}
            />
          </div>
        </section>

        {/* Testimonials */}
        <section className={`${styles.testimonials} container`}>
          <h3 className={styles.title}>{t("SuccessStoriesFromOurUsersPartners")}</h3>
          <div className={styles.wrapper}>
            <div className={styles.item}>
              <img src={starsIcon} alt={"Stars"} />
              <p>{t("ClubPassBroughtMeMoreBookings")}</p>
              <p className={styles.name}>
                {"Nikos from Athens"} <span>{t("GymOwner")}</span>
              </p>
            </div>

            <div className={styles.item}>
              <img src={starsIcon} alt={"Stars"} />
              <p>{t("ICanTryMultipleGymsWithoutSeparateSubscriptions")}</p>
              <p className={styles.name}>
                {"Maria from Thessaloniki"} <span>{t("Customer")}</span>
              </p>
            </div>

            <div className={styles.item}>
              <img src={starsIcon} alt={"Stars"} />
              <p>{t("FreeListingOnClubPassDoubledMyAppointments")}</p>
              <p className={styles.name}>
                {"Evgenia from Crete"} <span>{t("WellnessStudio")}</span>
              </p>
            </div>
          </div>
          <div className={"flex-just-center"}>
            <CustomButton
              functionOnClick={redirectToCalendly}
              text={t("JoinTheClubPassCommunity")}
              type={"button"}
              typeStyle={"fill"}
              style={{
                display: "inline-flex",
                width: "unset",
              }}
            />
          </div>
        </section>

        {/* Ready to join */}
        <section className={`${styles.ready} container`}>
          <div className={styles.box}>
            <h3>{t("ReadyJoinGetStartedNow")}</h3>
            <div className={styles.btnWrapper}>
              {/*<CustomButton*/}
              {/*  text={t("StartYourFreeTrial")}*/}
              {/*  type={"button"}*/}
              {/*  typeStyle={"fill"}*/}
              {/*  style={{*/}
              {/*    background: "#FFF",*/}
              {/*    color: "#000",*/}
              {/*  }}*/}
              {/*/>*/}
              <CustomButton
                functionOnClick={redirectToCalendly}
                text={t("ListYourBusinessForFree")}
                type={"button"}
                typeStyle={"outline"}
                icon={sendWhite}
                altIcon={"List"}
                style={{
                  background: "transparent",
                  color: "#FFF",
                  borderColor: "#FFF",
                  display: "inline-flex",
                  width: "unset",
                }}
              />
            </div>
          </div>
        </section>

        {showComingSoonPopup && <ComingSoonPopup close={() => setShowComingSoonPopup(false)} />}
      </div>
    </>
  );
};

export default Home;
